<div class="p-4">
  <mat-card class="p-6">
    @if (userLoading() || userRolesLoading()) {
      <div class="flex justify-center p-4">
        <mat-spinner></mat-spinner>
      </div>
    } @else if (userError() || userRolesError()) {
      <div class="flex justify-center p-4">
        <p class="text-red-500">{{ errorText }}</p>
      </div>
    } @else {
      <mat-card-header>
        <mat-card-title class="text-xl font-semibold pb-4"
          >{{ user.firstName }} {{ user.lastName }}</mat-card-title
        >
      </mat-card-header>

      <mat-card-content>
        <p class="pb-2">
          Created By: {{ user.createdBy?.firstName }} {{ user.createdBy?.lastName }}
        </p>
        <p class="pb-2">Created On: {{ user.dateCreated | date: CONFIG.date.formatWithTime }}</p>

        <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="mt-4">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <mat-form-field class="w-full">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" required />
              @if (userForm.get('firstName')?.hasError('required')) {
                <mat-error> First Name is required </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" required />
              @if (userForm.get('lastName')?.hasError('required')) {
                <mat-error> Last Name is required </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" />
              @if (userForm.get('email')?.hasError('required')) {
                <mat-error> Email is required </mat-error>
              }
              @if (
                userForm.get('email')?.hasError('email') &&
                !userForm.get('email')?.hasError('required')
              ) {
                <mat-error> Please enter a valid email address </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>Title</mat-label>
              <input matInput formControlName="title" />
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>Fax Number</mat-label>
              <input matInput formControlName="faxNumber" />
            </mat-form-field>
          </div>

          <div *ciwcRoleAccess="['ROLE_SUPER_ADMIN']" class="mb-8 flex items-center flex-col">
            <label class="block mb-2">User Permission</label>
            <mat-radio-group formControlName="roles" class="flex flex-col">
              @for (role of roles; track role.key) {
                <mat-radio-button [value]="role.key">
                  {{ role.value }}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="flex justify-end p-4 gap-[10px]">
        <button mat-flat-button (click)="goBack()" [disabled]="isEditing()">CANCEL</button>
        <button mat-flat-button color="accent" (click)="onSubmit()" [disabled]="isEditing()">
          SAVE CHANGES
        </button>
      </mat-card-actions>
    }
  </mat-card>
</div>
